<template>
    <br />
    <div id="layoutAuthentication" class="mt-3" v-if="mostraForm">
      <div id="layoutAuthentication_content">
          <main>
              <div class="container-xl px-4">
                  <div class="row justify-content-center">
                      <div class="col-lg-5">
                          <!-- Basic login form-->
                          <div class="card shadow-lg border-0 rounded-lg mt-5">
                            <div class="card-header justify-content-center">
                                <img style="width:250px;" src="img/poligeo.png" />
                                <hr style="" />
                                <h3 class="fw-light my-4">Accesso</h3>
                                <!-- <div class="row">
                                    <div class="col-md-8"></div>
                                    <div class="col-md-4"></div>
                                </div> -->
                                
                            </div>
                              <div class="card-body">
                                  <!-- Login form-->
                                  <form autocomplete="off">
                                    <template v-if="mostraLogin">
                                        <!-- Form Group (email address)-->
                                        <div class="mb-3">
                                            <label class="small mb-1">Nome utente o email</label>
                                            <input class="form-control" type="text" placeholder="inserire nome utente o email" v-model="oLogin.username" />
                                        </div>
                                        <!-- Form Group (password)-->
                                        <div class="mb-3">
                                            <label class="small mb-1" >Password</label>
                                            <input class="form-control" type="password" placeholder="inserire password" v-model="oLogin.password" @keyup.enter="DoLogin"/>
                                        </div>
                                        
                                        <!-- Form Group (login box)-->
                                        <div class="d-flex align-items-center justify-content-between mt-4 mb-0">
                                            <a class="small" href="javascript:void(0)" @click="MostraRec">Password dimenticata</a>
                                            <a class="btn btn-primary" href="#" @click="DoLogin">Login</a>
                                        </div>


                                    </template>

                                    <!-- Reset password form-->
                                    <template v-if="mostraReset">
                                        <strong>Reimpostazione password necessaria</strong>
                                        <!-- <div class="mb-3">
                                            <label class="small mb-1">Vecchia password</label>
                                            <input class="form-control" type="password" placeholder="" v-model="oLoginReset.vecchiap" />
                                        </div> -->
                                        <div class="mb-3">
                                            <label class="small mb-1" >Nuova password</label>
                                            <input class="form-control" type="password" placeholder="inserire nuova password" v-model="oLoginReset.nuovap"/>
                                        </div>
                                        <div class="mb-3">
                                            <label class="small mb-1" >Conferma password</label>
                                            <input class="form-control" type="password" placeholder="confermare password" v-model="oLoginReset.confermap"/>
                                        </div>

                                        <div class="d-flex align-items-center justify-content-between mt-4 mb-0">
                                            <a class="btn btn-primary" href="#" @click="DoPasswordChange">Cambia</a>
                                        </div>
                                    </template>
                                    
                                    <!-- Lost password form-->
                                    <template v-if="mostraRecover">
                                        <strong>Recupero password </strong>
                                        
                                        <div class="mb-3">
                                            <label class="small mb-1" >Nome utente</label>
                                            <input class="form-control" type="text" placeholder="nome utente" v-model="oLoginRecover.username"/>
                                        </div>
                                        <div class="mb-3">
                                            <label class="small mb-1" >Email fornita</label>
                                            <input class="form-control" type="text" placeholder="inserire l'email fornita" v-model="oLoginRecover.email"/>
                                        </div>

                                        <div class="d-flex align-items-center justify-content-between mt-4 mb-0">
                                            <a class="btn btn-secondary" href="#" @click="NascondiRec">Annulla</a>
                                            <a class="btn btn-primary" href="#" @click="DoRecovery">Invia richiesta</a>
                                        </div>
                                    </template>
                                      

                                      <messaggio-standard 
                                        :mostraMessaggio="mostraMessaggio"
                                        :alertClass="alertClass"
                                        :alertIcon="alertIcon"
                                        :alertIconSpin="alertIconSpin"
                                        :alertMessaggio="alertMessaggio"
                                        ></messaggio-standard>

                                  </form>
                              </div>
                              <div class="card-footer text-center">
                                  Coded by <a target="_blank" href="https://www.sndk.org">Sndk</a>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </main>
      </div>
     
  </div>
</template>

<script>
// @ is an alias to /src
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
  name: 'LoginView',
  components: { MessaggioStandard  },
  inject: ['cfg'],
  data: function() {
    return {
        mostraForm: true,
        oLogin: {
            username: "",
            password: ""
        },
        oLoginReset: {
            username: "",
            vecchiap: "",
            nuovap: "",
            confermap: "",
            tokenp: "",
        },
        oLoginRecover: {
            username: "",
            email: ""
        },

        mostraLogin: true,
        mostraReset: false,
        mostraRecover: false,

        mostraMessaggio: false,
        alertMessaggio: "",
        alertClass: "",     
        alertIcon: "",
        alertIconSpin: false  
    }
  },
  methods: {
    DoLogin () {
        
        this.mostraMessaggio = true;
        this.alertMessaggio = ["Accesso in corso..."]; //<i class='fas fa-circle-notch fa-spin'></i>&nbsp;
        this.alertClass = "alert alert-primary";
        this.alertIcon = "fa-spinner"
        this.alertIconSpin = true

        //Invia login 
        fetch(this.cfg.apisrv + "/api/User/DoLogin", {
                "method": "POST",
                "headers": {
                    'Accept': 'text/plain',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.oLogin)
            })
        .then(response => response.json())
        .then(obj => {
            if (obj.status == "OK") {
                //Setta lo store vuex con il token
                //this.$store.state.token = obj.dati[0];
                //this.$store.state.UserInfo = obj.moreJsonData;
                
                this.$store.commit('UserInfo', obj.moreJsonData);

                this.mostraMessaggio = true;
                this.alertMessaggio = ["Fatto. Redirezione in corso..."]; //<i class='fas fa-circle-notch fa-spin'></i>&nbsp;
                this.alertClass = "alert alert-success";
                this.alertIcon = "fa-spinner"
                this.alertIconSpin = true

                //alert(obj.moreJsonData.status)
                if(obj.moreJsonData.ute_idLivello <=2) {
                    this.$router.push("/dashboard");
                } else {
                    this.$router.push("/dashboard-clienti");
                }
                
                //window.location.href= "/dash";
                //alert(this.$store.state.token);
            }
            else {
                if(obj.nextStep == 'resetPass') {
                    this.mostraLogin = false;
                    this.mostraReset = true;
                    this.mostraMessaggio = false;

                    //Inizializza l'oggetto reset
                    this.oLoginReset.tokenp = obj.moreJsonData.token;
                    this.oLoginReset.username = this.oLogin.username;
                    this.oLoginReset.vecchiap = this.oLogin.password;


                } else {
                    this.mostraMessaggio = true;
                    this.alertMessaggio = [obj.errorMessage];
                    this.alertClass = "alert alert-warning";
                    this.alertIcon = "fa-xmark"
                    this.alertIconSpin = false

                }
                
            }
        });
      },
      DoPasswordChange () {
        
        this.mostraMessaggio = true;
        this.alertMessaggio = ["Cambio in corso..."]; //<i class='fas fa-circle-notch fa-spin'></i>&nbsp;
        this.alertClass = "alert alert-primary";
        this.alertIcon = "fa-spinner"
        this.alertIconSpin = true

        //Invia login 
        fetch(this.cfg.apisrv + "/api/User/DoPasswordChange", {
                "method": "POST",
                "headers": {
                    'Accept': 'text/plain',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.oLoginReset)
            })
        .then(response => response.json())
        .then(obj => {
            if (obj.status == "OK") {

                this.mostraMessaggio = true;
                this.alertMessaggio = ["Fatto. Rieseguire il login."];
                this.alertClass = "alert alert-success";
                this.alertIcon = "fa-check"
                this.alertIconSpin = false

                this.mostraLogin = true;
                this.mostraReset = false;

                
            }
            else {
                this.mostraMessaggio = true;
                this.alertMessaggio = [obj.errorMessage];
                this.alertClass = "alert alert-warning";
                this.alertIcon = "fa-xmark"
                this.alertIconSpin = false               
            }
        });
      },
      DoRecovery () {
        
        this.mostraMessaggio = true;
        this.alertMessaggio = ["Connessione in corso..."];
        this.alertClass = "alert alert-primary";
        this.alertIcon = "fa-spinner"
        this.alertIconSpin = true

        //Invia login 
        fetch(this.cfg.apisrv + "/api/User/DoRecovery", {
                "method": "POST",
                "headers": {
                    'Accept': 'text/plain',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.oLoginRecover)
            })
        .then(response => response.json())
        .then(obj => {
            if (obj.status == "OK") {

                this.mostraMessaggio = true;
                this.alertMessaggio = ["Mail inviata."];
                this.alertClass = "alert alert-success";
                this.alertIcon = "fa-check"
                this.alertIconSpin = false

                this.mostraLogin = true;
                this.mostraReset = false;
                this.mostraRecover = false;

                
            }
            else {
                this.mostraMessaggio = true;
                this.alertMessaggio = [obj.errorMessage];
                this.alertClass = "alert alert-warning";
                this.alertIcon = "fa-xmark"
                this.alertIconSpin = false               
            }
        });
      },


      MostraRec() {
        this.mostraLogin = false;
        this.mostraRecover = true;
        this.mostraMessaggio = false;
        this.oLoginRecover.username = this.oLogin.username;

      },
      NascondiRec() {
        this.mostraLogin = true;
        this.mostraRecover = false;
        this.mostraMessaggio = false;
      }

    },
  mounted: function() {
    if(this.$store.state.UserInfo.token == "") { this.mostraForm = true; }
    else { this.mostraForm = false; }
  }
}
</script>
